import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { StoreBaseService } from '../../common/base.service';
import { ArticleGalleryContentPayload } from './models/gallery-content-payload';
import { ArticleGalleryContent } from './models/gallery-content';

@Injectable({
  providedIn: 'root'
})
export class ArticleGalleryContentService
  extends StoreBaseService<ArticleGalleryContent, ArticleGalleryContentPayload> {

  get entityType(): string {
    return EntityTypes.articleGalleryContent;
  }

  get resourceName(): string {
    return 'gallery-content';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
